import { Component } from '@angular/core';

@Component({
  selector: 'app-plus-minus-icon',
  templateUrl: './plus-minus-icon.component.html',
  styleUrls: ['./plus-minus-icon.component.scss'],
  standalone: false
})
export class PlusMinusIconComponent {}
